import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-life',
  templateUrl: './product-life.component.html',
  styleUrls: ['./product-life.component.css']
})
export class ProductLifeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

}
